import React, { Component, PropTypes } from 'react';
import head from 'lodash/head';
import isUndefined from 'lodash/isUndefined';
import PresetColorPicker from '../../../widgets/PresetColorPicker';
import { convertRGBAToHexColor, splitRGBAValues } from '../theme-utils';

function parseGradient(gradient) {
    if (gradient) {
        let match = /gradient\(-?\d{2,3}deg, (?:(\#[0-9a-fA-F]{3,6}).*?(?:,\s)*)?(?:(\#[0-9a-fA-F]{3,6}).*?(?:,\s)*)?(?:(\#[0-9a-fA-F]{3,6}).*?(?:,\s)*)?(?:(\#[0-9a-fA-F]{3,6}).*?(?:,\s)*)\)$/g.exec(
            gradient
        );
        return match ? match.splice(1) : [gradient, ''];
    }
}

function parseGradientType(gradient) {
    return head(gradient.split('('));
}

function parseGradientDegrees(gradient) {
    return head(gradient.match(/-?\d{2,3}deg/));
}

/**
 *
 * @param gradientType - string - linear-gradient/repearting-linear-gradient
 * @param gradientDegrees - string - -45deg / 135deg
 * @param colors - array of hex colors
 * @returns {*} gradient string
 */
function buildGradient(gradientType, gradientDegrees, colors) {
    const definedColors = colors.filter(color => !!color);
    if (isValidGradient(gradientType) && definedColors.length > 1) {
        if (gradientType === 'linear-gradient') {
            return `${gradientType}(${gradientDegrees}, ${colors[0]}, 50%, ${colors[3]} 50%)`;
        } else if (colors.length > 1 && gradientType === 'repeating-linear-gradient') {
            return `${gradientType}(${gradientDegrees}, ${colors[0]}, ${colors[1]} 5px, ${colors[0]} 5px, ${colors[0]} 10px)`;
        }
    } else {
        return colors[0];
    }
}

function isValidGradient(gradientType) {
    return ['repeating-linear-gradient', 'linear-gradient'].includes(gradientType);
}

// for linear-gradients, 2nd color is actually the 4th color in the array since the regex parses 2 undefined colors for 2nd and 3rd index
const labels = ['1st', '2nd', '', '2nd'];

export class CalendarColorPicker extends Component {
    static propTypes = {
        color: PropTypes.string,
        onColorChange: PropTypes.func
    };
    static defaultProps = {
        color: '',
        onColorChange: () => {}
    };

    constructor(props) {
        super(props);
        const gradientType = parseGradientType(props.color);
        this.colorArraySize = gradientType === 'repeating-linear-gradient' ? 2 : 4;
        this.state = {
            colors: parseGradient(props.color).splice(0, this.colorArraySize),
            gradientType,
            gradientDegrees: parseGradientDegrees(props.color),
            displayColorPicker: false,
            openedPicker: -1
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.color !== nextProps.color) {
            this.setState({
                colors: parseGradient(nextProps.color).splice(0, this.colorArraySize)
            });
        }
    }

    handleClick = event => {
        this.setState({
            displayColorPicker: !this.state.displayColorPicker
        });
    };
    handleClose = event => {
        this.setState({
            displayColorPicker: false
        });
    };

    handleChangeComplete = i => event => {
        const colors = [...this.state.colors];
        const newValue = _.get(event, 'target.value');

        if (newValue.startsWith('#')) {
            colors[i] = newValue;
        } else if (newValue.startsWith('rgba')) {
            const rgbaValues = splitRGBAValues(newValue);
            colors[i] = convertRGBAToHexColor(rgbaValues);
        }

        this.setState(
            {
                colors
            },
            () =>
                this.props.onColorChange({
                    target: {
                        value: buildGradient(this.state.gradientType, this.state.gradientDegrees, this.state.colors)
                    }
                })
        );
    };

    render() {
        const buttonStyle = {
            cursor: 'pointer',
            background: buildGradient(this.state.gradientType, this.state.gradientDegrees, this.state.colors)
        };
        return (
            <span className={this.props.className}>
                <button
                    style={buttonStyle}
                    disabled={this.props.isDisabled}
                    className="preset-color-picker-button"
                    onClick={this.handleClick}
                />
                {this.state.displayColorPicker ? (
                    <div className="preset-color-picker-popover">
                        <div className="preset-color-picker-cover" onClick={this.handleClose} />
                        {this.state.colors.map((color, i) => {
                            return !isUndefined(color) ? (
                                <div className="col-xs">
                                    <PresetColorPicker
                                        color={color}
                                        isDisabled={this.props.isDisabled}
                                        onColorChange={this.handleChangeComplete(i)}
                                    />
                                </div>
                            ) : null;
                        })}
                    </div>
                ) : null}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/theme/calendar/CalendarColorPicker.js